import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../style.css';

function CertificacionesIngles() {
  const certs = [
    {
      name: "Cambridge",
      description: "Certificación válida a nivel mundial. Si quieres comprobar tu nivel de inglés en cualquier parte del mundo, esta es tu mejor opción.",
      image: "/assets/cambridge.JPG",
      link: "https://www.cambridgeenglish.org/latinamerica/exams-and-tests/qualifications/",
      tag: "Mundial",
      color: "var(--blue)",
    },
    {
      name: "CENNI (SEP)",
      description: "Certificación válida en México. Ideal para obtener tu título universitario o un empleo que requiera comprobar tu nivel de inglés.",
      image: "/assets/cenni.JPG",
      link: "https://dgair.sep.gob.mx/dir/cenni",
      tag: "México",
      color: "#059669",
    },
    {
      name: "ELeT by UKS",
      description: "Examen computarizado con resultados inmediatos. Alineado al MCER y al programa CENNI de la SEP.",
      image: "/assets/ELET_UKS.JPG",
      link: "https://www.uks.mx/productos/elet/",
      tag: "Digital",
      color: "#7c3aed",
    },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Certificaciones de Inglés | Culturlingua — Cambridge, CENNI, ELeT</title>
        <meta name="description" content="Obtén tu certificación de inglés en Culturlingua. Cambridge, CENNI SEP y ELeT by UKS. Preparación con profesores certificados en Tlaquepaque." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">Certifícate</div>
        <h1>Certificaciones de Inglés</h1>
        <p>Prueba tu nivel y abre puertas con una certificación reconocida.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1100px', margin:'0 auto'}}>
          <div style={{textAlign:'center', marginBottom:'60px'}}>
            <h2 className="section-headline">Certificaciones que ofrecemos</h2>
            <p className="section-sub" style={{margin:'0 auto'}}>
              Más de 6,000 instituciones en 110 países confían en estas certificaciones para evaluar el nivel de inglés.
            </p>
          </div>

          <div className="cards-grid">
            {certs.map((cert) => (
              <div className="modal-card" key={cert.name}>
                <div className="modal-card-accent" style={{background:`linear-gradient(90deg, ${cert.color}, ${cert.color}88)`}}></div>
                <div className="modal-card-body">
                  <img
                    src={cert.image}
                    alt={cert.name}
                    style={{width:'100%', height:'160px', objectFit:'contain', marginBottom:'20px', borderRadius:'8px', background:'#f9f9f9', padding:'12px'}}
                  />
                  <span className="section-tag" style={{background:`${cert.color}15`, color:cert.color, borderColor:`${cert.color}30`}}>{cert.tag}</span>
                  <h3 style={{marginTop:'8px'}}>{cert.name}</h3>
                  <p>{cert.description}</p>
                  <a href={cert.link} target="_blank" rel="noopener noreferrer" className="modal-link">
                    Más información →
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center', marginTop:'60px'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              ¿No sabes qué certificación necesitas?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'32px', maxWidth:'480px', margin:'0 auto 32px'}}>
              Contáctanos y te ayudamos a elegir la certificación más adecuada para tus metas.
            </p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/Examen-de-ubicacion" className="btn-glow">Hacer examen de ubicación</Link>
              <Link to="/contacto" className="btn-outline">Contáctanos</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CertificacionesIngles;
